/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { WorkbookId } from "../../commons/types/WorkbookId";
export const SpaceSidebarConfig = core.serialization.object({
    workbookSidebarOrder: core.serialization.list(WorkbookId).optional(),
});
